import { FunctionComponent } from "preact";
import { memo } from "preact/compat";

const ChevronLeft: FunctionComponent = memo(() => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fal"
      data-icon="chevron-left"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      style={{
        display: "inline-block",
        height: "1em",
        verticalAlign: "-0.125em",
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
      }}
    >
      <path
        fill="currentColor"
        d="M234.8 36.25c3.438 3.141 5.156 7.438 5.156 11.75c0 3.891-1.406 7.781-4.25 10.86L53.77 256l181.1 197.1c6 6.5 5.625 16.64-.9062 22.61c-6.5 6-16.59 5.594-22.59-.8906l-192-208c-5.688-6.156-5.688-15.56 0-21.72l192-208C218.2 30.66 228.3 30.25 234.8 36.25z"
      ></path>
    </svg>
  );
});

ChevronLeft.displayName = "ChevronLeft";

export default ChevronLeft;
